import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useController, UseControllerProps } from 'react-hook-form';
import { formControlColour, tooltipColour } from '../BEE123.Constants';

import { IconButton, OutlinedInputProps, TextField, Tooltip } from '@mui/material';

interface IProps extends UseControllerProps {
  disabled?: boolean | undefined;
  label: string;
  multiline?: boolean;
  rows?: number;
  type?: string;
  value?: string;
  size?: "small" | "medium";
  onChange?: (value: any) => void;
  onBlur?: (value: any) => void;
  InputProps?: Partial<OutlinedInputProps> | undefined;
  showDescription?: boolean;
  descriptionText?: string;
  showCustomError?: boolean;
  customText?: string;
  showError?: boolean;  
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

const AppTextInput = (props: IProps) => {
  const { fieldState, field } = useController({ ...props, defaultValue: undefined });
  return (
    <TextField
      {...props}
      {...field}
      value={field.value === 0 ? 0 : field.value || ''}
      fullWidth
      variant='outlined'
      type={props.type}
      error={!!fieldState.error || props.showError}
      helperText={fieldState.error?.message}
      multiline={props.multiline}
      rows={props.rows}
      disabled={props.disabled || false}
      size={props.size}  
      onKeyDown={props.onKeyDown}
      onBlur={(value) => {
        field.onBlur();
        if (props.onBlur) {
          if (value != null) {
            props.onBlur(value);
          }
        }
      }}
      onChange={(value) => {
        field.onChange(value);
        if (props.onChange) {
          if (value != null) {
            props.onChange(value);
          }
        }
      }
      }
      InputProps={{
        endAdornment: props.showDescription ? (
          <Tooltip
            title={props.descriptionText!}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: tooltipColour,
                  '& .MuiTooltip-arrow': {
                    color: tooltipColour
                  },
                },
              },
            }}
            placement="right"
          >
            <IconButton
              size="small"
              edge="end"
              color="inherit"
              aria-label="info"
            >
              <InfoOutlinedIcon style={{ color: formControlColour }} />
            </IconButton>
          </Tooltip>
        ) : null,
        ...props.InputProps
      }}
    />
  )
}

export default AppTextInput